import {useLocation} from 'react-router-dom';
import {useEffect} from 'react';
const ScrollToTop = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        document.documentElement.scrollTo({
            top: 0,
            left: 0,
            // @ts-expect-error
            behavior: 'instant',
        });
    }, [pathname]);

    return null;
};

export default ScrollToTop;